import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { withNamespaces } from 'react-i18next';

class GradeDetailsLink extends Component {
	constructor(props) {
		super(props);
		this.showInfoDialog = this.showInfoDialog.bind(this);
		this.hideInfoDialog = this.hideInfoDialog.bind(this);
		this.state = {
			showInfoDialog: false
		};
	}

	showInfoDialog() {
		this.setState({
			showInfoDialog: true
		});
	}

	hideInfoDialog() {
		this.setState({
			showInfoDialog: false
		});
	}

	renderInfoDialog() {
		const { grade } = this.props;

		const header = grade && grade.name;
		const body = grade && <div dangerouslySetInnerHTML={{ __html: grade.description }} />;

		return <Dialog show={this.state.showInfoDialog} onHide={this.hideInfoDialog} header={header} body={body} />;
	}

	render() {
		const { grade } = this.props;
		const infoDialog = this.renderInfoDialog();

		return grade ? <span>
			<a style={{ cursor: 'pointer' }} onClick={this.showInfoDialog}>{grade.name}</a>
			{infoDialog}
		</span> : null;
	}
}

GradeDetailsLink.propTypes = {
	grade: PropTypes.shape({
		name: PropTypes.string,
		description: PropTypes.string
	})
};

export default withNamespaces()(GradeDetailsLink);